import React from "react";
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize } from '../common/responsive.utils';
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import NaverBlog from '../../assets/icon/component/footer/naver_blog.svg';
import Instagram from '../../assets/icon/component/footer/instagram.svg';

const Footer = ({...props}) : React.ReactElement => {
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();
    const navigate = useNavigate();

    const onIR = () => {
        window.open("mailto:sungsoo@spacepet.info", "_blank")
    }

    const pressNaverBlog = () => {
        window.open("https://blog.naver.com/spacepetofficial", "_blank")
    }

    const pressInstagram = () => {
        window.open("https://www.instagram.com/space.pet_official/", "_blank")
    }

    const onTerm = () => {
        window.open("https://spacepet.notion.site/14aee7caac7381f2a4f4c06d887ad055?pvs=4", "_blank")
    }

    const onPrivacyTerm = () => {
        window.open("https://spacepet.notion.site/14aee7caac7381489396faa837ef7569?pvs=4", "_blank")
    }

    const onGeometryTerm = () => {
        window.open("https://spacepet.notion.site/14aee7caac7381f98be0daae621c0c23?pvs=4", "_blank")
    }

    const onMain = () => {
        navigate("/")
    }

    const onSitter = () => {
        navigate("/sitter")
    }


    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.footerCon01_Web}>
                        <div style={styles.footerRowCon05_Web}>
                            <p style={styles.footerTxt01_Web} onClick={() => onMain()}>우주펫 소개</p>
                            <div style={{ width: 24 }} />
                            <p style={styles.footerTxt01_Web} onClick={() => onSitter()}>이웃시터 소개</p>
                        </div>

                        <div style={{ height: 68 }} />

                        <div style={styles.footerRowCon01_Web} >
                            <p style={styles.footerTxt01_Web} onClick={() => onIR()}>제휴/IR문의</p>

                            <div style={styles.footerRowCon02_Web} >
                                <div style={styles.footerIconCon_Web} onClick={() => pressNaverBlog()}>
                                    <img src={NaverBlog} alt="" />
                                </div>

                                <div style={styles.footerIconCon_Web} onClick={() => pressInstagram()}>
                                    <img src={Instagram} alt="" />
                                </div>
                            </div>
                        </div>

                        <div style={{ height: 44 }} />

                        <p style={styles.footerTxt02_Web} >주식회사 우주펫</p>

                        <div style={{ height: 20 }} />

                        <p style={styles.footerTxt03_Web}>대표 : 박성수 | 사업자등록번호 : 860-81-02850</p>

                        <div style={{ height: 12 }} />

                        <p style={styles.footerTxt03_Web}>통신판매업신고번호 : 2023-서울강남-01239</p>

                        <div style={{ height: 12 }} />

                        <p style={styles.footerTxt03_Web}>주소 : 서울특별시 강남구 역삼로 165 (역삼동) 7층 c호</p>

                        <div style={{ height: 12 }} />

                        <p style={styles.footerTxt03_Web}>​‌고객센터 : 010. 2276. 0834</p>

                        <div style={{ height: 12 }} />

                        <div style={styles.footerRowCon04_Web}>
                            <p style={styles.footerTxt03_Web}>이메일 : spacepetofficial@gmail.com</p>

                            <div style={styles.footerRowCon03_Web} >
                                <p style={styles.footerTxt04_Web} onClick={() => onTerm()}>이용약관</p>
                                <div style={{ width: 16 }} />
                                <p style={styles.footerTxt04_Web} onClick={() => onPrivacyTerm()}>개인정보처리방침</p>
                                <div style={{ width: 16 }} />
                                <p style={styles.footerTxt04_Web} onClick={() => onGeometryTerm()}>위치기반 서비스 약관</p>
                            </div>
                        </div>

                        <div style={{ height: 66 }} />

                        <p style={styles.footerTxt05_Web} >spacepet.site © 2021 ALL RIGHTS RESERVED.</p>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.homeFooterCon_Mobile} >
                        <div style={styles.footerCon_Mobile} >
                            <div style={styles.footerBtnCon_Mobile}>
                                <img src={NaverBlog} style={styles.footerBtn} alt="" onClick={() => pressNaverBlog()} />
                                <div style={{ width: 18 }} />
                                <img src={Instagram} style={styles.footerBtn} alt="" onClick={() => pressInstagram()} />
                            </div>

                        </div>

                        <a style={styles.footerBtn01_Mobile} href="mailto:sungsoo@spacepet.info"><p style={styles.footerBtn02_Mobile}>제휴/IR문의</p></a>

                        <p style={styles.footerText01_Mobile}>주식회사 우주펫</p>

                        <div style={{ height: "3vw" }} />

                        <div style={styles.footerTextCon_Mobile}>
                            <p style={styles.footerContentTxt_Mobile}>대표 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}> 박성수</p>
                            <div style={styles.footerVertDivider_Mobile} />
                            <p style={styles.footerContentTxt_Mobile}>사업자등록번호 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}>860-81-02850</p>
                        </div>

                        <div style={styles.footerTextCon1_Mobile}>
                            <p style={styles.footerContentTxt_Mobile}>통신판매업신고번호 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}>2023-서울강남-01239</p>
                        </div>

                        <div style={styles.footerTextCon1_Mobile}>
                            <p style={styles.footerContentTxt_Mobile}>주소 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}>서울특별시 강남구 역삼로 165 (역삼동) 7층 c호</p>
                        </div>

                        <div style={styles.footerTextCon_Mobile}>
                            <p style={styles.footerContentTxt_Mobile}>고객센터 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}>010.2276.0834</p>
                        </div>

                        <div style={styles.footerTextCon_Mobile}>
                            <p style={styles.footerContentTxt_Mobile}>이메일 :&nbsp;</p>
                            <p style={styles.footerContentTxt_Mobile}>spacepetofficial@gmail.com</p>
                        </div>

                        <div style={{ height: "9vw" }} />

                        <div style={styles.footerTextCon_Mobile}>
                            <p style={styles.footerTextBtn_Mobile} onClick={() => onTerm()}>이용약관&nbsp;&nbsp;</p>
                            <p style={styles.footerTextBtn_Mobile} onClick={() => onPrivacyTerm()}>개인정보처리방침&nbsp;&nbsp;</p>
                            <p style={styles.footerTextBtn_Mobile} onClick={() => onGeometryTerm()}>위치기반 서비스 약관&nbsp;&nbsp;</p>
                        </div>

                        <p style={styles.footerClcTxt_Mobile}>spacepet.site © 2021 ALL RIGHTS RESERVED.</p>

                        <div style={{ height: "5vw" }} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    footerCon01_Web: { width: "100%", display: "flex", flexDirection: "column", boxSizing: "border-box", backgroundColor: "#FFFFFF", paddingTop: responsivePaddingVertical(39, 60), paddingBottom: responsivePaddingVertical(50, 68), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(20, 88) },
    footerRowCon05_Web: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" },
    footerTxt01_Web: { padding: 0, margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(12, 24), fontWeight: "600", lineHeight: "23.87px", letterSpacing: "-0.01em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#797A7C" },
    footerRowCon01_Web: { width: "100%", padding: 0, margin: 0, display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" },
    footerRowCon02_Web: { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    footerIconCon_Web: { width: responsiveImageSize(22, 44), height: responsiveImageSize(22, 44), margin: 0, padding: 10 },
    footerTxt02_Web: { padding: 0, margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(13, 26), fontWeight: "700", lineHeight: "31.2px", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#353535" },
    footerTxt03_Web: { padding: 0, margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(12, 20), fontWeight: "400", lineHeight: "24px", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#62686D" },
    footerRowCon04_Web: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    footerRowCon03_Web: { display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center" },
    footerTxt04_Web: { padding: 0, margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(11, 18), fontWeight: "600", lineHeight: "21.6px", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#9FA5AD" },
    footerTxt05_Web: { padding: 0, margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(10, 16), fontWeight: "400", lineHeight: "19.2px", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#BDC1C5" },
    
    button_Mobile: {width:"100%", minWidth: "320px", backgroundColor: "#9F6BFF", paddingTop: "2.4969vh",paddingBottom: "2.4969vh", position: "fixed",  display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center", left: "50%", transform: "translate(-50%, 0)",  margin: "auto", zIndex: 999},
    buttonTxt_Mobile: { fontSize: "5vw", fontWeight: 700,letterSpacing: "-1%",textAlign: "center",color: "white", lineHeight: "120%"},
    homeFooterCon_Mobile: { width: " 100%", height: "auto", paddingBottom: responsivePaddingVertical(44, 68), paddingTop: responsivePaddingVertical(30, 79), paddingLeft: responsivePaddingHorizontal(24, 72), paddingRight: responsivePaddingHorizontal(49, 78), boxSizing: "border-box" },
    footerCon_Mobile: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", },
    footerBtnCon_Mobile: { display: "flex", flexDirection: "row", marginTop: "0px", marginBottom: "5vw" },
    footerBtn01_Mobile: { marginTop: "0px", marginBottom: "5vw", color: "#797A7C", fontWeight: 600, display: "flex", flexDirection: "row", textDecoration: "none" },
    footerText01_Mobile: { fontWeight: 600, color: "#393939", fontSize:responsiveFont(13, 26), marginTop: "0px", marginBottom: "16px", lineHeight: "120%" },
    footerTextCon_Mobile: { display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center", marginTop: "0px", marginBottom: "1.8750vw" },
    footerContentTxt_Mobile: { color: "#726E6E", fontWeight: 500, fontSize: responsiveFont(12, 20), lineHeight: "120%", marginTop: 0, marginBottom: 0 },
    footerVertDivider_Mobile: { width: "0.1563vw", height: "2.5000vw", backgroundColor: "#726E6E", marginLeft: "2.5000vw", marginRight: "2.5000vw" },
    footerTextCon1_Mobile: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyItems: "center", marginTop: 0, marginBottom: "1.8750vw" },
    footerTextBtn_Mobile: { margin: "0 0 0 0", color: "#9FA5AD", fontWeight: 600, fontSize: responsiveFont(11, 18), letterSpacing: "-2%" },
    footerClcTxt_Mobile: { color: "#AAAAAA", marginTop: "3vw", marginBottom: 0, fontWeight: 500, fontSize: responsiveFont(10, 16)},
    footerBtn02_Mobile: { marginTop: 0, marginBottom: 0, color: "#797A7C", fontWeight: 600, fontSize: responsiveFont(12, 20), textDecoration: "none" },
});

export default Footer;